import { render } from "./VehicleWithdrawalResponsibles.vue?vue&type=template&id=207ba0c7"
import script from "./VehicleWithdrawalResponsibles.vue?vue&type=script&lang=ts"
export * from "./VehicleWithdrawalResponsibles.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
